var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('buttons.switchView'),"title":_vm.$t('buttons.switchView'),"id":"switch-view-button"},on:{"click":_vm.change}},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.switchView')))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3646c37a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/SwitchView.vue
// module id = 364
// module chunks = 0